import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import { getApiErrorMessage } from "src/types/api";


export interface iUpdateUserState {
    name: string;
    position: string;
    department: string;
    
    response: any;
    isLoading: boolean;
    message: string;
}


const initialState: iUpdateUserState = {
    name: '',
    position: '',
    department: '',
    response: [],
    isLoading: false,
    message: ""
}


const postUpdateUserInfoApi = createAsyncThunk(
  "POST_UPDATE_USER_INFO",
  async(
      user: { 
        name?: string; 
        position: string; 
        department: string;
        email?: string;
        batch_num : number
      },
      { rejectWithValue }) => {
      try {
        const pathParam = '/auth/update-info/'
        const djangoEndpoint = getDjangoEndpoint();

        const response = await axiosInstance.patch(
          `${djangoEndpoint}${pathParam}`,
          {
            name: user.name,
            position: user.position,
            department: user.department,
            batch_num : user.batch_num,
            ...(user.email && { email: user.email }), // 이메일이 있을 때만 추가
          },
          {
            withCredentials: true,
          }
        );
        return response.data;
      } catch (error) {
          return rejectWithValue(getApiErrorMessage(error));
      }
  }
);

const updateUserInfoSlice = createSlice({
    name: "update-user-info",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postUpdateUserInfoApi.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postUpdateUserInfoApi.fulfilled, (state, action) => {
                state.isLoading = false;
                state.message = action.payload.message ;
                state.name = action.payload.name || state.name;
                state.position = action.payload.position || state.position;
                state.department = action.payload.department || state.department;
                state.response = action.payload;
            })
            .addCase(postUpdateUserInfoApi.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string ;
            });
    }
});

export { postUpdateUserInfoApi };
export default updateUserInfoSlice.reducer;